import * as actionTypes from 'containers/Campaigns/action-types';
import ArraysUtils from 'utils/arrays';
import { CampaignColumnsKeys, CampaignColumnsKeysType } from 'utils/campaigns';

export const clearSelection = () => selectCampaign(null);

export const selectArchivedColumn = (
  id: CampaignColumnsKeysType,
  selectedColumns: Array<CampaignColumnsKeysType>
) => {
  if (id === 'all') {
    return {
      type: actionTypes.ARCHIVED_COLUMNS_SET,
      payload: CampaignColumnsKeys
    };
  } else {
    return {
      type: actionTypes.ARCHIVED_COLUMNS_SET,
      payload: ArraysUtils.addOrRemove(id, selectedColumns)
    };
  }
};

export const selectCampaign = (id: string) => ({
  type: actionTypes.CAMPAIGN_SELECT,
  payload: id
});

export const selectCampaignColumn = (
  id: CampaignColumnsKeysType,
  selectedColumns: Array<CampaignColumnsKeysType>
) => {
  if (id === 'all') {
    return {
      type: actionTypes.CAMPAIGN_COLUMNS_SET,
      payload: CampaignColumnsKeys
    };
  } else {
    return {
      type: actionTypes.CAMPAIGN_COLUMNS_SET,
      payload: ArraysUtils.addOrRemove(id, selectedColumns)
    };
  }
};

export const selectTab = (value: string) => ({
  type: actionTypes.TAB_SELECT,
  payload: value
});

export const setErrorMessage = (message: string) => ({
  type: actionTypes.ERROR_MESSAGE_SET,
  payload: message
});

export const openViewCampaignModal = (id: string) => ({
  type: actionTypes.VIEW_CAMPAIGN,
  payload: id
});

export const setShow = (value: boolean) => ({
  type: actionTypes.SHOW_SET,
  payload: value
});

export const setCampaign = (campaign: any) => ({
  type: actionTypes.CAMPAIGN_SET,
  payload: campaign
});
